export default "#define GLSLIFY 1\nuniform vec3 color;\nuniform float opacity;\n\nvoid main() {\n\tgl_FragColor = vec4(color, opacity);\n}\n";